import Tile from "../GraphicTile/GraphicTile.js";
import Data from "../../Assets/Content/StrategyData.js";
import imageMapResize from "image-map-resizer";
import { useEffect } from "react";

const CycleEconomyMap = (props) => {
  const { setContent, economyType, setFixText } = props.AppStateService;

  useEffect(() => {
    imageMapResize();
  }, []);

  return (
    <map name="image-map-full">
      <Tile
        AppStateService={{ setContent, economyType, setFixText }}
        coords="520,110,870,110,870,160,520,160"
        content={Data.SharingPlatforms}
        alt={Data.SharingPlatforms.heading}
      />
      <Tile
        AppStateService={{ setContent, economyType, setFixText }}
        coords="520,200,870,200,870,250,520,250"
        content={Data.ProductAsAService}
        alt={Data.ProductAsAService.heading}
      />
      <Tile
        AppStateService={{ setContent, economyType, setFixText }}
        coords="520,290,870,290,870,340,520,340"
        content={Data.ReparaturUndWartung}
        alt={Data.ReparaturUndWartung.heading}
      />
      <Tile
        AppStateService={{ setContent, economyType, setFixText }}
        coords="80,410,430,410,430,460,80,460"
        content={Data.WasteAsAResource}
        alt={Data.WasteAsAResource.heading}
      />
      <Tile
        AppStateService={{ setContent, economyType, setFixText }}
        coords="80,500,430,500,430,550,80,550"
        content={Data.ModularesDesign}
        alt={Data.ModularesDesign.heading}
      />
      <Tile
        AppStateService={{ setContent, economyType, setFixText }}
        coords="80,590,430,590,430,640,80,640"
        content={Data.SuffizienzUnterstützen}
        alt={Data.SuffizienzUnterstützen.heading}
      />
      <Tile
        AppStateService={{ setContent, economyType, setFixText }}
        coords="900,410,1233,410,1233,460,900,460"
        content={Data.Wiederaufbereiten}
        alt={Data.Wiederaufbereiten.heading}
      />
      <Tile
        AppStateService={{ setContent, economyType, setFixText }}
        coords="900,500,1233,500,1233,550,900,550"
        content={Data.Wiederverkauf}
        alt={Data.Wiederverkauf.heading}
      />
      <Tile
        AppStateService={{ setContent, economyType, setFixText }}
        coords="900,590,1233,590,1233,640,900,640"
        content={Data.Recycling}
        alt={Data.Recycling.heading}
      />
    </map>
  );
};

export default CycleEconomyMap;
